const eventStatus = {
  ACTIVE: 1,
  IDLE: 2,
  DRAFT: 3,
};

export default eventStatus;
